import { render, staticRenderFns } from "./MyCollectionsIndex.vue?vue&type=template&id=9d64ff1c"
import script from "./MyCollectionsIndex.vue?vue&type=script&lang=js"
export * from "./MyCollectionsIndex.vue?vue&type=script&lang=js"
import style0 from "./MyCollectionsIndex.vue?vue&type=style&index=0&id=9d64ff1c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports